var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pretty p-switch p-fill" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.extrasMode,
          expression: "extrasMode"
        }
      ],
      attrs: { type: "checkbox" },
      domProps: {
        checked: Array.isArray(_vm.extrasMode)
          ? _vm._i(_vm.extrasMode, null) > -1
          : _vm.extrasMode
      },
      on: {
        change: function($event) {
          var $$a = _vm.extrasMode,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 && (_vm.extrasMode = $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                (_vm.extrasMode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.extrasMode = $$c
          }
        }
      }
    }),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "state p-warning" }, [
      _c("label", [_vm._v("Extras")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }